// extracted by mini-css-extract-plugin
export default {"formControl":"PrimaryInput_formControl__aB4FH","label":"PrimaryInput_label__VEqy7","primaryInput":"PrimaryInput_primaryInput__q-Y8c"};